export const getBackendUri = (): string => {
  const fallback = import.meta.env.DEV ? "http://localhost:3001" : "no-backend-selected";
  return import.meta.env.VITE_BACKEND_URL ?? fallback;
};
